export default __webpack_public_path__ + "static/media/14.42b4ceff.jpg";